import AabTile from './AabTile';

customElements.define('aab-tile', AabTile);
